module.exports = __webpack_public_path__ + "static/media/Galdisa_FavaBeans.1f415ab6.pdf";